import { Box,  Stack, Typography } from "@mui/material";
import React from "react";
 
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/textile/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function CoordinationTools() {
  const products = [
    "textile waste reduction and recycling software",


  ];
  const data = {
    image: "/industries/textile/textile-waste-reduction-and-recycling-software.jpg", // Replace with the appropriate image URL
    intro: `Optimize your apparel manufacturing operations with our state-of-the-art Apparel Manufacturing ERP Systems. Explore how our comprehensive solutions streamline processes, enhance collaboration, and drive efficiency across your entire supply chain.`,
    keyFeatures: [
        {
            title: "Production Planning and Scheduling",
            content: "Plan and schedule production activities efficiently to optimize manufacturing processes.",
        },
        {
            title: "Inventory Management and Control",
            content: "Manage and control inventory effectively, ensuring optimal stock levels and reducing holding costs.",
        },
        {
            title: "Order Processing and Tracking",
            content: "Streamline order processing and tracking to enhance order fulfillment and customer satisfaction.",
        },
        {
            title: "Supply Chain Visibility",
            content: "Gain real-time visibility into the supply chain for better decision-making and responsiveness.",
        },
        {
            title: "Financial Management and Reporting",
            content: "Integrate financial management tools to streamline accounting processes and generate insightful reports.",
        },
    ],
    howItWorks: `Delve into the seamless integration of our ERP systems, from production planning to financial management, ensuring a synchronized and efficient apparel manufacturing process.`,
    benefits: {
        title: "The benefits of Apparel Manufacturing ERP Systems",
        data: [
            "Improved Production Efficiency",
            "Enhanced Collaboration Among Teams",
            "Real-time Supply Chain Visibility",
            "Cost Reduction through Process Optimization",
        ],
    },
    industries: `Tailored for:
- Apparel Manufacturers
- Fashion Brands and Retailers
- Textile Mills
- Garment Production Units`,
    stories: `Explore success stories of businesses that have elevated their manufacturing processes with our Apparel Manufacturing ERP Systems.`,
    contactUs: `Connect with our team to discuss how ERP Systems can enhance your apparel manufacturing efficiency and profitability.`,
    futureDevelopments: `Stay updated on the latest features and innovations shaping the future of ERP technology in apparel manufacturing.`,
    technology: `Learn about the compatibility of our ERP systems with other manufacturing technologies and supply chain management systems.`,
    support: `Access training programs and support services to ensure effective implementation and utilization of Apparel Manufacturing ERP Systems.`,
    industry: `Discover how our ERP systems align with industry standards and regulatory compliance in apparel manufacturing.`,
    events: "Stay informed about industry events and collaborations driving advancements in ERP technology for apparel manufacturing.",
    blog: `Explore our blog and knowledge hub for insights into ERP technology, apparel manufacturing trends, and industry best practices.`,
    careers: `Discover career opportunities and join us in shaping the future of ERP technology for apparel manufacturing.`,
};

  
  

  

  
  
  
  const content = "Embark on a textile innovation journey with us! Whether you're involved in advanced textile technologies, supply chain optimization, sustainable practices, or any aspect of the textile industry, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our textile solutions align seamlessly with your goals, budget, and scope."
    return (
    <>
     <Head>
    <title>Textile Waste Reduction and Recycling Software | Promote Sustainability | Techbrain Networks</title>
    <meta name="description" content="Promote sustainability in textile manufacturing with Techbrain Networks Textile Waste Reduction and Recycling Software, designed to minimize waste and enhance recycling efforts." />
    <meta name="keywords" content="textile waste reduction, recycling software, sustainability, Techbrain Networks" />
    <meta property="og:title" content="Textile Waste Reduction and Recycling Software | Promote Sustainability | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Textile Waste Reduction and Recycling Software helps minimize waste and promote recycling in textile manufacturing, enhancing sustainability." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/textile/products/textile-waste-reduction-and-recycling-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Textile Waste Reduction and Recycling Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Textile Waste Reduction and Recycling Software | Promote Sustainability" />
    <meta name="twitter:description" content="Enhance sustainability in textile manufacturing with Techbrain Networks software, designed to reduce waste and improve recycling processes." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/textile/products/textile-waste-reduction-and-recycling-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Textile Waste Reduction and Recycling Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Promote sustainability in textile manufacturing with Techbrain Networks Waste Reduction and Recycling Software, designed to minimize waste and enhance recycling efforts.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/textile/products/textile-waste-reduction-and-recycling-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
 <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#F73D93"} />

      <AppbarIndustry title={"Textile"} homeLink={'/industries/textile'} link={'/industries/textile/products'} />
    <HeroSection img={'/industries/textile/textile-waste-reduction-and-recycling-software.jpg'}>
    textile waste reduction and recycling software







    </HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#0f0118",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F73D93"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#F73D93"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#F73D93",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F73D93"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#F73D93"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
  {/* Industries */}
  <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F73D93"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

         

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F73D93"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in spacecraft thermal analysis and design technology.

          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F73D93"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F73D93"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#0f0118",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F73D93"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#F73D93",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
           <Box
            sx={{
              width: ["100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#F73D93"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      <FooterIndustry ourProducts={ourProducts} color={"#F73D93"} bg={"#0f0118"} />
    </>
  );
}

export default CoordinationTools;
